module.exports = __webpack_public_path__ + "img/straight_line_icon_123.fd4b5124.svg";